import type { Category } from '~/data/categories';

interface Props {
  icon: Category['icon'];
}

export function CategoryIcon(props: Props) {
  const stroke = 'currentColor';
  switch (props.icon) {
    case 'engine':
      return (
        <svg viewBox="0 0 48 48" width="36" height="36" fill="none" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="8" y="18" width="32" height="20" rx="2.5" />
          <path d="M12 18v-4h6v4M30 18v-4h6v4" />
          <path d="M14 26h20M14 32h20" />
          <path d="M40 24h4M4 24h4" />
        </svg>
      );
    case 'gearbox':
      return (
        <svg viewBox="0 0 48 48" width="36" height="36" fill="none" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="24" cy="24" r="10" />
          <path d="M24 14V8M24 40v-6M14 24H8M40 24h-6M16.5 16.5L13 13M35 35l-3.5-3.5M16.5 31.5L13 35M35 13l-3.5 3.5" />
          <circle cx="24" cy="24" r="3" />
        </svg>
      );
    case 'axle':
      return (
        <svg viewBox="0 0 48 48" width="36" height="36" fill="none" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="24" r="7" />
          <circle cx="36" cy="24" r="7" />
          <path d="M19 24h10" />
          <circle cx="12" cy="24" r="2" />
          <circle cx="36" cy="24" r="2" />
        </svg>
      );
    case 'fuel':
      return (
        <svg viewBox="0 0 48 48" width="36" height="36" fill="none" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="10" y="10" width="20" height="30" rx="2.5" />
          <path d="M14 18h12M14 26h12" />
          <path d="M30 18h4l4 4v14a3 3 0 0 1-3 3" />
          <path d="M34 14v4" />
        </svg>
      );
    case 'turbo':
      return (
        <svg viewBox="0 0 48 48" width="36" height="36" fill="none" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="24" cy="24" r="11" />
          <path d="M24 14a10 10 0 0 1 9 6M34 24a10 10 0 0 1-6 9M24 34a10 10 0 0 1-9-6M14 24a10 10 0 0 1 6-9" />
          <circle cx="24" cy="24" r="3.5" />
        </svg>
      );
    case 'rare':
      return (
        <svg viewBox="0 0 48 48" width="36" height="36" fill="none" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M24 6l4 8 9 1.5-6.5 6.4 1.6 9.1L24 26.7 15.9 31l1.6-9.1L11 15.5 20 14z" />
          <path d="M14 38h20" />
        </svg>
      );
  }
}
